import ApplicationController from './application_controller';

// Connects to data-controller="retrospective-report-toc"
//
// 振り返りレポートの全体表示では全ステップが1ページに並ぶため、
// いま画面にある節を目次側に反映する。ステップごとの表示ではサーバー側で分かるので使わない。
export default class extends ApplicationController {
  static targets = ['link'];

  connect() {
    super.connect();

    // 節はページの生存中に変わらないため、DOMの参照は接続時の1回で確定させる。
    // 並び順のまま持つことで、複数が同時に見えているときに上の節を選べる。
    this.sections = this.linkTargets
      .map((link) => document.querySelector(link.hash))
      .filter((section) => section);

    this.visibleIds = new Set();
    this.observer = new IntersectionObserver(this.handleIntersect, {
      // 画面の上寄りに入った節を「いまここ」とみなす。
      rootMargin: '0px 0px -60% 0px',
    });

    this.sections.forEach((section) => this.observer.observe(section));
  }

  disconnect() {
    this.observer.disconnect();
  }

  handleIntersect = (entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        this.visibleIds.add(target.id);
      } else {
        this.visibleIds.delete(target.id);
      }
    });

    this.markCurrent();
  };

  // 複数の節が同時に見えている場合は、文書の並び順で最初のものを採る。
  markCurrent() {
    const currentId = this.sections
      .map((section) => section.id)
      .find((id) => this.visibleIds.has(id));

    this.linkTargets.forEach((link) => {
      if (link.hash === `#${currentId}`) {
        link.setAttribute('aria-current', 'step');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }
}
